var map = {
	"./de.json": [
		86575,
		6575
	],
	"./en-PH.json": [
		46952,
		6952
	],
	"./en.json": [
		24743,
		4743
	],
	"./es.json": [
		24292,
		1911
	],
	"./fr.json": [
		77100,
		7100
	],
	"./it.json": [
		49705,
		9705
	],
	"./pl.json": [
		22148,
		2148
	],
	"./pt.json": [
		29308,
		9308
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99070;
module.exports = webpackAsyncContext;